import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconThumbUpCurved: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconThumbUpCurved"><Path d="M2.5 9.5H7.5V20.5H2.5V9.5Z" stroke="currentColor"/><Path d="M12.3727 2.56015L11.8841 2.5C10.5 6.5 7.5 8.60318 7.5 11.2707V18.117C7.5 18.9418 7.98142 19.704 8.76823 19.9862C11.4383 20.9438 14.2313 21.1486 17.0548 20.9076C18.7791 20.7605 20.1303 19.449 20.5102 17.786L21.4199 13.8041C21.8743 11.8149 20.3384 9.92396 18.2682 9.92396H13.0377L14.0596 6.653C14.6501 4.76274 14.3652 2.80546 12.3727 2.56015Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconThumbUpCurved;
